export default {
  IS_LOGIN(state) {
    state.loginStatus = true;
  },
  NOT_LOGIN(state) {
    state.loginStatus = false;
  },
  HAS_LOGGED_OUT(state) {
    state.loginStatus = null;
  },

  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo;
  },
  SET_MCH_DETAIL(state, mchDetail) {
    state.mchDetail = mchDetail;
  },

  SET_MENU_LIST(state, privileges) {
    state.userInfo.privileges = privileges;
  },

  SET_REGISTER_KEY(state, register_key) {
    state.register_key = register_key;
  },
  SET_DOWN_LIST (state, downList) {
    state.downList = downList
  },
  SET_BROWSER(state, browser) {
    state.browser = browser;
  },
};
